import EnrolmentsSerializer from './base';

export default class Schema extends EnrolmentsSerializer {}
